import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Pagination } from 'src/app/models/pagination.model';
import { Candidate } from 'src/app/models/candidate.model';
import { fromCandidates } from 'src/app/reducers/candidates.reducer';
import { fromCandidateSearch } from 'src/app/reducers/candidate-search.reducer';
import { Process } from 'src/app/models/process.model';
import { fromProcesses } from 'src/app/reducers/processes.reducer';
import { fromProcessSearch } from 'src/app/reducers/process-search.reducer';
import { setProcessSearch } from 'src/app/actions/process-search.actions';
import { take } from 'rxjs/operators';
import { setProcesses } from 'src/app/actions/processes.actions';
import { ProcessService } from 'src/app/services/process.service';
import { fromConsultant } from 'src/app/reducers/consultant.reducer';
import { UtilsService } from 'src/app/services/utils.service';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Consultant } from 'src/app/models/consultant.model';
import { AppConfig } from 'src/app/helpers/app.config';

@Component({
  selector: 'ct-processes',
  templateUrl: './processes.component.html',
  styleUrls: ['./processes.component.scss']
})
export class ProcessesComponent implements OnInit {

  @ViewChild('content') content;
  processSearchForm: FormGroup = this.fb.group({
    processName: [''],
  });

  processes$: Observable<Pagination<Process>>;

  processToDelete: Process;
  modalRef: NgbModalRef;
  closeResult: string;
  consultant: Consultant;
  constructor(
    private store: Store,
    private ngZone: NgZone,
    private fb: FormBuilder,
    private processService: ProcessService,
    public utilsService: UtilsService,
    private router: Router,
    private modal: NgbModal,
  ) { }

  ngOnInit(): void {
    this.processes$ = this.store.pipe(select(fromProcesses.selectProcessesState));
    // comprobamos si venimos desde busqueda de candidatos ya que al venir de ali se ejecuta 2 veces sino la llamada de /process
    // (creemos que por el cambio de pagina en el reload)
    if (localStorage.getItem('lastUrl') !== '/consultant/candidates') {
      this.searchProcess(1, '');
    }
    localStorage.setItem('lastUrl', this.router.url);
    // Nos guardamos el consultor para posteriormente usarlo
    this.consultant = Object.assign(new Consultant(), JSON.parse(localStorage.getItem('consultant')));
  }

  deleteProcess() {
    this.processService.delete(
      { id: this.processToDelete.id, officeId: this.processToDelete.officeId, consultantId: this.consultant.raas.nameid, clientId: this.consultant.client.id }
    ).subscribe(result => {
      this.searchProcess(1, '');
      this.utilsService.toast('success', 'ProcessDeleted');
      this.modal.dismissAll('Cross click');
    }, error => {
      if (error.cause.cause.errorCode === 4032) {
        this.utilsService.toast('error', 'ProfileCanNotDelete');
        this.modal.dismissAll('Cross click');
      } else {
        this.utilsService.toast('error', 'CannotDeleteProcess', true, this.utilsService.getNacsData({ endpoint: 'DELETE' + AppConfig.settings.API + ' /processes?origin=ct', body: { id: this.processToDelete.id, officeId: this.processToDelete.officeId, consultantId: this.consultant.raas.nameid }, error: { errorType: error.errorType, errorCode: error.errorCode, message: error.message } }));
        this.modal.dismissAll('Cross click');
      }
    });
  }

  onSubmit() {
    this.searchProcess(1, this.processSearchForm.get('processName').value);
  }

  searchProcess(page: number, name) {
    this.store.pipe(select(fromConsultant.selectConsultantState)).pipe(take(1)).subscribe(consultant => {
      this.ngZone.run(() => {
        this.processService.search({
          name,
          clientId: consultant.client.id,
          officeId: consultant.office.id,
        }, page).pipe(take(1)).subscribe(
          processes => this.store.dispatch(setProcesses(processes)),
          error => this.utilsService.toast('error', 'CannotGetProcesses', true, this.utilsService.getNacsData({ endpoint: 'GET' + AppConfig.settings.API + ' /processes?origin=ct', body: { name: '', clientId: consultant.client.id, officeId: consultant.office.id }, error: { errorType: error.errorType, errorCode: error.errorCode, message: error.message } }))
        );
      });
    });
  }

  showModalDeleteProcess(process: Process) {
    this.processToDelete = process;
    if (!this.modal.hasOpenModals()) {
      this.modalRef = this.modal.open(this.content, {
        ariaLabelledBy: 'Eliminar-Proceso', size: 'l', centered: true, backdrop: 'static', keyboard: false
      });
      this.modalRef.result.then((result) => {
        this.closeResult = 'Closed with: ' + result;
      }, (reason) => {
        this.closeResult = 'Dismissed ' + this.getDismissReason(reason);
      });
    }
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return 'with: ' + reason;
    }
  }
}
